/** Vencimentos: o que está vencido ou a vencer, de todas as fontes (ver GET /vencimentos). */

export const HORIZONTES = [30, 60, 90] as const;
export type Horizonte = (typeof HORIZONTES)[number];

export type SituacaoDeVencimento = 'vencido' | 'vence_em_breve' | 'no_prazo';

export interface ItemDeVencimento {
  tipo: string;
  rotulo: string;
  item: string;
  empresaId: number | null;
  empresa: string | null;
  /** YYYY-MM-DD */
  vencimentoEm: string;
  /** 0 é hoje; negativo já venceu. */
  diasRestantes: number;
  situacao: SituacaoDeVencimento;
}

export interface AgrupamentoDeVencimento {
  chave: string;
  rotulo: string;
  vencidos: number;
  venceEmBreve: number;
  total: number;
}

export interface PainelDeVencimentos {
  horizonteEmDias: number;
  total: number;
  vencidos: number;
  venceEmBreve: number;
  porTipo: AgrupamentoDeVencimento[];
  porEmpresa: AgrupamentoDeVencimento[];
  itens: ItemDeVencimento[];
}
